<ion-grid>
  <section class="filters">
    <ion-row class="container">
      <ion-col size="12">
        <ion-card class="filters__card">
          <ion-card-header class="filters__card__header">
            <ion-card-title>Listado de solicitudes</ion-card-title>
          </ion-card-header>
          <form autocomplete="off" [formGroup]="filterRequestForm">
            <ion-row class="filters__card__row">
              <ion-col size="12" sizeMd="3" class="filters__card__col">
                <app-input [formGroup]="filterRequestForm" label="Contenido" formControlName="content" type="select"
                  [options]="filterContentList" [required]="false" [defaultValueSelect]="defaultValueSelect" />
              </ion-col>
              <ion-col size="12" sizeMd="3" class="filters__card__col">
                <app-input [formGroup]="filterRequestForm" label="Nombre y apellidos" formControlName="userEmail" type="selectwithsearch" [displayValue]="getName(filterRequestForm.get('userEmail')?.value)"
                  [options]="filterNameList" [required]="false" [defaultValueSelect]="defaultValueSelect" />
              </ion-col>
              <ion-col size="12" sizeMd="3" class="filters__card__col">
                <app-input [formGroup]="filterRequestForm" label="Empresa" formControlName="company" [displayValue]="getCompany(filterRequestForm.get('company')?.value)" type="selectwithsearch"
                  [options]="filterCompanyList" [required]="false" [defaultValueSelect]="defaultValueSelect" />
              </ion-col>
              <ion-col size="12" sizeMd="3" class="filters__card__col">
                <app-input [formGroup]="filterRequestForm" label="Estado" formControlName="state" type="select"
                  [options]="stateCompanyList" [required]="false" [defaultValueSelect]="defaultValueSelect" />
              </ion-col>
            </ion-row>
          </form>
        </ion-card>
      </ion-col>
    </ion-row>
  </section>
  <section class="requests">
    <ion-row class="container">
      <ion-col size="12">
        @if (requests) { @if (requests.length > 0) {
        <ion-card class="requests__card">
          <ion-grid class="requests__table">
            <ion-row class="requests__table__row requests__table--header ion-align-items-center">
              <ion-col class="ion-padding" size="1"><strong>Contenido</strong></ion-col>
              <ion-col class="ion-padding" size="2"><strong>Nombre y Apellidos</strong></ion-col>
              <ion-col class="ion-padding" size="2"><strong>Email</strong></ion-col>
              <ion-col class="ion-padding" size="2"><strong>Empresa</strong></ion-col>
              <ion-col class="ion-padding" size="1"><strong>Fecha de registro</strong></ion-col>
              <ion-col class="ion-padding" size="1"><strong>Estado</strong></ion-col>
              <ion-col class="ion-padding" size="1"><strong>Fecha de estado</strong></ion-col>
              <ion-col class="ion-padding" size="2"><strong>Responsable</strong></ion-col>
              <ion-col class="ion-padding" size="1"></ion-col>
              <ion-item-divider class="divider divider--header"></ion-item-divider>
            </ion-row>
            @for (req of requests; track $index) {
            <ion-row class="ion-align-items-center requests__table__row">
              <ion-col class="ion-padding col-text-break" size="1">{{ req.name }}</ion-col>
              <ion-col class="ion-padding col-text-break" size="2">{{ req.firstName }} {{ req.lastName }} </ion-col>
              <ion-col class="ion-padding col-text-break" size="2">{{ req.email }}</ion-col>
              <ion-col class="ion-padding col-text-break" size="2">{{ req.company }}</ion-col>
              <ion-col class="ion-padding" size="1">{{ req.createdAt |
                date:'dd/MM/yyyy'}}</ion-col>
              <ion-col class="ion-padding" size="1">{{ getState(req.state) }}</ion-col>
              <ion-col class="ion-padding" size="1">{{ req.updatedAt |
                date:'dd/MM/yyyy'}}</ion-col>
              <ion-col class="ion-padding col-text-break" size="2" style="display: unset;">{{ req.manager }}</ion-col>
              <ion-col class="ion-padding" size="1">
                @if (req.authorized) {
                <ion-icon
                (click)="openModal($event, req)" class="custom-icon-table icon icon-dots-vertical"
                  aria-label="Ver más opciones de gestión de solicitudes" role="button"></ion-icon>
                }
              </ion-col>
              <ion-item-divider class="divider divider--body"></ion-item-divider>
            </ion-row>
            }
            @if (requests && requests.length < 1) {
              <ion-row class="ion-align-items-center requests__table__row">
                <ion-col class="ion-padding" size="4">No existen datos</ion-col>
              </ion-row>
              }
          </ion-grid>
          @if (hasMoreItems) {
          <ion-row class="ion-justify-content-center ion-padding">
            <a class="load-more-link" (click)="loadMore()">
              Ver más
            </a>
          </ion-row>
          }
        </ion-card>
      } @else {
        <app-general-error type="warning" code="no-data.requests" />
        } }
      </ion-col>
    </ion-row>
  </section>
</ion-grid>
